webpackJsonp([4],{

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _row = __webpack_require__(109);

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__(108);

var _col2 = _interopRequireDefault(_col);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(165);

__webpack_require__(164);

var _blockContentToReact = __webpack_require__(171);

var _blockContentToReact2 = _interopRequireDefault(_blockContentToReact);

var _imageUrl = __webpack_require__(166);

var _imageUrl2 = _interopRequireDefault(_imageUrl);

var _polished = __webpack_require__(262);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(90);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Hero = __webpack_require__(983);

var _Hero2 = _interopRequireDefault(_Hero);

var _Seperator = __webpack_require__(719);

var _Seperator2 = _interopRequireDefault(_Seperator);

var _sanitySerializers = __webpack_require__(269);

var _sanitySerializers2 = _interopRequireDefault(_sanitySerializers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import Talkyard from '../components/Talkyard'
var TopHero = (0, _styledComponents2.default)(_Hero2.default).withConfig({
  displayName: 'Article__TopHero'
})(['color:', ';padding-bottom:6px;'], function (p) {
  return p.theme.textOffwhite;
});
var Preface = _styledComponents2.default.p.withConfig({
  displayName: 'Article__Preface'
})(['white-space:pre-line;font-size:1.3em;']);
var StCol = (0, _styledComponents2.default)(_col2.default).withConfig({
  displayName: 'Article__StCol'
})(['color:', ';h2 + h3{margin-top:0;}h2,h3{color:#fff;&:not(:first-child){margin-top:1.5em;& + h3,& + h2{margin-top:0;}}code{color:', ';font-size:92%;margin-top:-10px;}}ul{list-style:square;}'], function (p) {
  return p.theme.textGrey;
}, function (p) {
  return p.theme.textGrey;
});

var Article = function (_React$Component) {
  _inherits(Article, _React$Component);

  function Article(props) {
    _classCallCheck(this, Article);

    var _this = _possibleConstructorReturn(this, (Article.__proto__ || Object.getPrototypeOf(Article)).call(this, props));

    var _getSerializers = (0, _sanitySerializers2.default)(props.siteData),
        marks = _getSerializers.marks,
        types = _getSerializers.types;

    _this._serializers = {
      marks: marks,
      types: {
        image: types.image
      }
    };
    return _this;
  }

  _createClass(Article, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$article = _props.article,
          title = _props$article.title,
          preface = _props$article.preface,
          prefaceBlock = _props$article.prefaceBlock,
          body = _props$article.body,
          meta = _props$article.meta,
          mainImage = _props$article.mainImage,
          _props$siteData$sanit = _props.siteData.sanityConfig,
          projectId = _props$siteData$sanit.projectId,
          dataset = _props$siteData$sanit.dataset,
          theme = _props.theme;

      var chosenPreface = prefaceBlock ? _react2.default.createElement(_blockContentToReact2.default, { blocks: prefaceBlock, serializers: this._serializers }) : preface;
      var metaDescription = meta && meta.description ? _react2.default.createElement('meta', { name: 'description', content: meta.description }) : null;
      var metaTitle = _react2.default.createElement(
        'title',
        null,
        meta && meta.title || title
      );
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _reactStatic.Head,
          null,
          metaTitle,
          metaDescription
        ),
        _react2.default.createElement(
          TopHero,
          { imagePlaceholder: mainImage.metadata.lqip, imageSrc: this.state.heroImageSrc, trace: this._heroImageSrc, color: (0, _polished.darken)(0.1, theme.main), isCentered: true, parallaxOffset: 200, opacity: 0.2, minHeight: '40vh' },
          _react2.default.createElement(
            _row2.default,
            { type: 'flex', align: 'middle', justify: 'center' },
            _react2.default.createElement(
              _col2.default,
              { xs: 22, sm: 20, md: 18, lg: 16, xl: 14 },
              _react2.default.createElement(
                'h1',
                null,
                title
              ),
              _react2.default.createElement(
                Preface,
                null,
                chosenPreface
              )
            )
          )
        ),
        _react2.default.createElement(_Seperator2.default, null),
        _react2.default.createElement(
          _row2.default,
          { style: { margin: '50px 0' }, type: 'flex', align: 'middle', justify: 'center' },
          _react2.default.createElement(
            StCol,
            { xs: 20, sm: 20, md: 16, lg: 12 },
            _react2.default.createElement(_blockContentToReact2.default, { blocks: body, serializers: this._serializers, imageOptions: { w: 650, h: 300, fit: 'max' }, projectId: projectId, dataset: dataset })
          )
        ),
        _react2.default.createElement(_Seperator2.default, null)
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      return {
        heroImageSrc: (0, _imageUrl2.default)(nextProps.siteData.sanityConfig).image(nextProps.article.mainImage).url()
      };
    }
  }]);

  return Article;
}(_react2.default.Component);

exports.default = (0, _reactStatic.withSiteData)((0, _reactStatic.withRouteData)((0, _styledComponents.withTheme)(Article)));

/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _pattern = __webpack_require__(720);

var _pattern2 = _interopRequireDefault(_pattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Patterend = _styledComponents2.default.div.withConfig({
    displayName: 'Seperator__Patterend'
})(['background-repeat:repeat;background-image:url(', ');height:', ';background-color:#4d4d4d;box-shadow:inset 0px 1px 10px 3px rgba(0,0,0,0.65);'], _pattern2.default, function (props) {
    return props.h ? parseFloat(props.h) + 'px' : '30px';
});

var Seperator = function (_Component) {
    _inherits(Seperator, _Component);

    function Seperator() {
        _classCallCheck(this, Seperator);

        return _possibleConstructorReturn(this, (Seperator.__proto__ || Object.getPrototypeOf(Seperator)).apply(this, arguments));
    }

    _createClass(Seperator, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(Patterend, this.props);
        }
    }]);

    return Seperator;
}(_react.Component);

exports.default = Seperator;

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJ0lEQVQImW3KsREAIBDDMIVhfyiWDQUdhysVDgbablie0vYime9xAFJvB2oasN26AAAAAElFTkSuQmCC"

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _polished = __webpack_require__(262);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _utils = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Root = _styledComponents2.default.div.withConfig({
    displayName: 'Hero__Root'
})(['position:relative;min-height:', ';height:auto;display:flex;flex-direction:column;justify-content:', ';align-items:', ';text-align:', ';'], function (props) {
    return props.minHeight;
}, function (props) {
    return props.isCentered ? 'center' : 'flex-start';
}, function (props) {
    return props.isCentered ? 'center' : 'stretch';
}, function (props) {
    return props.isCentered ? 'center' : 'left';
});
var Cover = _styledComponents2.default.div.withConfig({
    displayName: 'Hero__Cover'
})(['position:absolute;top:0;right:0;bottom:0;left:0;']);
var Img = (0, _styledComponents2.default)(Cover).withConfig({
    displayName: 'Hero__Img'
})(['background-attachment:', ';background-image:url(', ');background-position:center;background-repeat:no-repeat;background-size:', ';opacity:', ';transition-duration:', ';transition-property:opacity;transition-timing-function:', ';'], function (props) {
    return props.isFixed ? 'fixed' : 'scroll';
}, function (props) {
    return props.src;
}, function (props) {
    return props.width ? props.width + 'px ' + props.height + 'px' : 'cover';
}, function (props) {
    return props.isVisible ? 1 : 0;
}, function (props) {
    return props.transitionDuration + 'ms';
}, function (props) {
    return props.transitionTimingFunction;
});
var Overlay = (0, _styledComponents2.default)(Cover).withConfig({
    displayName: 'Hero__Overlay'
})(['min-height:100%;display:flex;justify-content:', ';align-items:', ';text-align:', ';background-color:', ';'], function (props) {
    return props.isCentered ? 'center' : 'flex-start';
}, function (props) {
    return props.isCentered ? 'center' : 'stretch';
}, function (props) {
    return props.isCentered ? 'center' : 'left';
}, function (props) {
    return (0, _polished.transparentize)(props.opacity, props.color);
});

var Hero = function (_Component) {
    _inherits(Hero, _Component);

    function Hero(props) {
        _classCallCheck(this, Hero);

        var _this = _possibleConstructorReturn(this, (Hero.__proto__ || Object.getPrototypeOf(Hero)).call(this, props));

        _this.updateBestSize = function () {
            var newBestSize = [200, 400, 600, 900, 1200, 1600, 2000, 2500, 3000, 3600, 4000].find(function (size) {
                return size >= _this.ref.offsetWidth;
            });
            var bestSize = _this.state.bestSize && _this.state.bestSize >= newBestSize ? _this.state.bestSize : newBestSize;
            _this.setState({ bestSize: bestSize });
        };
        _this.state = {
            backgroundPositionY: 'center',
            backgroundDimensions: null,
            heroDimensions: null,
            image: null,
            isInViewport: false
        };
        _this.handleResize = _this.handleResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.updatePosition = _this.updatePosition.bind(_this);
        _this.updateSize = _this.updateSize.bind(_this);
        return _this;
    }

    _createClass(Hero, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateBestSize();
            if (this.props.parallaxOffset > 0) {
                window.addEventListener('scroll', this.handleScroll);
                window.addEventListener('resize', this.handleResize);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.props.imageSrc !== prevProps.imageSrc || this.state.bestSize !== prevState.bestSize) {
                this.loadImage();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.parallaxOffset > 0) {
                window.removeEventListener('scroll', this.handleScroll);
                window.removeEventListener('resize', this.handleResize);
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll() {
            this.updatePosition();
        }
    }, {
        key: 'handleResize',
        value: function handleResize() {
            this.updateBestSize();
            this.updateSize();
            this.updatePosition();
        }
    }, {
        key: 'loadImage',
        value: function loadImage() {
            var _this2 = this;

            var image = new Image();
            (0, _utils.checkWebPSupport)('lossless', function (feature, support) {
                var format = support ? 'webp' : 'png';
                image.src = (0, _utils.addQuery)(_this2.props.imageSrc, {
                    w: _this2.state.bestSize,
                    fit: 'min',
                    fm: format
                });
                image.onload = function () {
                    _this2.setState({ image: image });
                    if (_this2.props.parallaxOffset > 0) {
                        _this2.updateSize();
                        _this2.updatePosition();
                    }
                };
            });
        }
    }, {
        key: 'updateSize',
        value: function updateSize() {
            if (!this.state.image) return;
            var heroDimensions = {
                height: this.ref.offsetHeight,
                width: this.ref.offsetWidth
            };
            var imageDimensions = {
                height: this.state.image.height,
                width: this.state.image.width
            };
            var resizedImage = (0, _utils.resizeToCover)(imageDimensions, heroDimensions);
            var initialVisibleImageHeight = resizedImage.height - this.props.parallaxOffset;
            var minHeight = initialVisibleImageHeight < heroDimensions.height ? resizedImage.height + heroDimensions.height - initialVisibleImageHeight : resizedImage.height;
            var finalHeight = minHeight + this.ref.offsetTop * 2;
            var backgroundDimensions = (0, _utils.resizeToCover)(imageDimensions, {
                height: finalHeight
            });
            this.setState({ backgroundDimensions: backgroundDimensions, heroDimensions: heroDimensions });
        }
    }, {
        key: 'updatePosition',
        value: function updatePosition() {
            if (!this.state.backgroundDimensions) return;
            var position = 0 + this.ref.offsetTop -
            // Center image vertically
            this.state.backgroundDimensions.height / 2 + this.state.heroDimensions.height / 2 - this.props.parallaxOffset / 2 +
            // Apply scroll position
            this.props.parallaxOffset * (0, _utils.scrolledOverPercent)(this.ref);
            this.setState({ backgroundPositionY: Math.round(position) + 'px' });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _state = this.state,
                backgroundDimensions = _state.backgroundDimensions,
                backgroundPositionY = _state.backgroundPositionY;

            return _react2.default.createElement(
                Root,
                { className: this.props.className, ref: function ref(r) {
                        _this3.ref = r;
                    }, isCentered: this.props.isCentered, minHeight: this.props.minHeight, style: this.props.style },
                _react2.default.createElement(Img, { height: backgroundDimensions && backgroundDimensions.height, isFixed: this.props.isFixed || this.props.parallaxOffset > 0, src: this.state.image && this.state.image.src, isVisible: !!this.state.image, style: { backgroundPositionY: backgroundPositionY }, transitionDuration: this.props.transitionDuration, transitionTimingFunction: this.props.transitionTimingFunction, width: backgroundDimensions && backgroundDimensions.width }),
                _react2.default.createElement(Img, { height: backgroundDimensions && backgroundDimensions.height, isFixed: this.props.isFixed || this.props.parallaxOffset > 0, src: this.props.imagePlaceholder, isVisible: !this.state.image, style: { backgroundPositionY: backgroundPositionY }, transitionDuration: this.props.transitionDuration, transitionTimingFunction: this.props.transitionTimingFunction, width: backgroundDimensions && backgroundDimensions.width }),
                _react2.default.createElement(Overlay, { color: this.props.color, isCentered: this.props.isCentered, opacity: this.props.opacity }),
                _react2.default.createElement(
                    'div',
                    { style: { transform: 'translateZ(0)', width: '100%' } },
                    this.props.children
                )
            );
        }
    }]);

    return Hero;
}(_react.Component);

Hero.defaultProps = {
    children: undefined,
    className: undefined,
    color: '#fff',
    imageSrc: undefined,
    isCentered: true,
    isFixed: false,
    minHeight: '33vh',
    opacity: 0.2,
    parallaxOffset: 0,
    style: undefined,
    transitionDuration: 600,
    transitionTimingFunction: 'ease-in-out'
};
Hero.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    imageSrc: _propTypes2.default.string,
    isCentered: _propTypes2.default.bool,
    isFixed: _propTypes2.default.bool,
    minHeight: _propTypes2.default.string,
    opacity: _propTypes2.default.number,
    parallaxOffset: _propTypes2.default.number,
    style: _propTypes2.default.object,
    transitionDuration: _propTypes2.default.number,
    transitionTimingFunction: _propTypes2.default.string
};
exports.default = Hero;

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Article.186740a5.js